import {
  ADD_OR_REMOVE_SURVEY_JOB,
  ADD_OR_REMOVE_SURVEY_JOB_BY_CODE,
  BULK_SELECT_SURVEY_JOB_CODES,
  BULK_SELECT_SURVEY_JOBS,
  CLEAR_SEARCH,
  CLEAR_SELECTED_SURVEY_JOBS,
  PROPAGATE_MATCHES_ERROR,
  PROPAGATE_MATCHES_SUCCESS,
  SET_SURVEY_JOB_FACET_TEXT,
  START_PROPAGATE_MATCHES,
  TOGGLE_SHOW_SELECTED_SURVEY_JOBS
} from './SurveyJobsActions';

const initialState = {
  isSelected: true,
  propMatches: {
    loading: false,
    propagatedMatches: {}
  },
  searchText: '',
  selectedSurveyJobCodes: [],
  surveyJobs: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_OR_REMOVE_SURVEY_JOB: {
      const id = action.id;
      const { surveyJobs } = state;
      const newSelectedSurveyJobs = !surveyJobs.includes(id)
        ? [...surveyJobs, id]
        : surveyJobs.filter(job => job !== id);

      return {
        ...state,
        surveyJobs: newSelectedSurveyJobs
      };
    }
    case ADD_OR_REMOVE_SURVEY_JOB_BY_CODE: {
      const { matchId } = action.data;
      const { selectedSurveyJobCodes } = state;
      const existsInArray = selectedSurveyJobCodes.some(val => val.matchId === matchId);
      const newSurveyJobs = existsInArray
        ? selectedSurveyJobCodes.filter(job => job.matchId !== matchId)
        : [...selectedSurveyJobCodes, action.data];

      return {
        ...state,
        selectedSurveyJobCodes: newSurveyJobs
      };
    }
    case BULK_SELECT_SURVEY_JOB_CODES: {
      const newSelectedSurveyJobs = action.jobs.map(job => {
        const [surveyCode, surveyJobCode] = job.split('::');
        return {
          matchId: job,
          surveyCode,
          surveyJobCode
        };
      });

      return {
        ...state,
        selectedSurveyJobCodes: newSelectedSurveyJobs
      };
    }
    case BULK_SELECT_SURVEY_JOBS: {
      return {
        ...state,
        surveyJobs: action.jobs
      };
    }
    case CLEAR_SEARCH: {
      return {
        ...state,
        isSelected: true,
        searchText: ''
      };
    }
    case CLEAR_SELECTED_SURVEY_JOBS: {
      return {
        ...state,
        propMatches: {
          loading: false,
          propagatedMatches: {}
        },
        selectedSurveyJobCodes: [],
        surveyJobs: []
      };
    }
    case PROPAGATE_MATCHES_ERROR: {
      return {
        ...state,
        propMatches: {
          loading: false,
          propagatedMatches: {}
        }
      };
    }
    case PROPAGATE_MATCHES_SUCCESS: {
      return {
        ...state,
        propMatches: {
          loading: false,
          propagatedMatches: action.propagatedMatches
        }
      };
    }
    case SET_SURVEY_JOB_FACET_TEXT: {
      return {
        ...state,
        searchText: action.data
      };
    }
    case TOGGLE_SHOW_SELECTED_SURVEY_JOBS: {
      return {
        ...state,
        isSelected: !state.isSelected
      };
    }
    case START_PROPAGATE_MATCHES: {
      return {
        ...state,
        propMatches: {
          loading: true,
          propagatedMatches: {}
        }
      };
    }
    default:
      return { ...state };
  }
}
